interface ClipboardOptions {
    onCopy?: Function
}

export function useClipboard(options?: ClipboardOptions) {
    const copied = ref(false)

    async function copy(text: string, container?: HTMLInputElement) {
        if (!navigator.clipboard) {
            const el = container || document.createElement('textarea')
            if (!container) {
                el.value = text
                el.style.top = '0'
                el.style.left = '0'
                el.style.position = 'fixed'
                document.body.appendChild(el)
            }

            el.focus()
            el.select()

            try {
                document.execCommand('copy')
                if (!container) document.body.removeChild(el)
                if (options?.onCopy) options.onCopy()
                copied.value = true
                setTimeout(() => (copied.value = false), 1500)
                return Promise.resolve()
            } catch (err) {
                if (!container) document.body.removeChild(el)
                return Promise.reject(err)
            }
        }

        copied.value = true
        if (options?.onCopy) options.onCopy()
        setTimeout(() => (copied.value = false), 2000)

        return navigator.clipboard.writeText(text)
    }

    return {
        copy,
        copied,
    }
}
